import {
  SET_INSIGHTS_FILTERS,
  RESET_INSIGHTS_FILTERS, SUCCESS
} from '../actions/types';

const INITIAL_STATE = {
  filters: {},
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_INSIGHTS_FILTERS:
      return { ...state, filters: { ...state.filters, ...action.payload.filters } };

    case RESET_INSIGHTS_FILTERS + SUCCESS:
      return { ...state, filters: action.payload.filters };

    default:
      return { ...state };
  }
}
